import { updateToken, updateUserId } from '../actions'
import { createReducer } from '@reduxjs/toolkit'

type UserInfoState = {
  userId: string | null
  token: string | null // 登录后的 token，null 为未登录
  phone: string | null
  name: string | null
}
const initialState: UserInfoState = {
  userId: null,
  token: null,
  phone: null,
  name: null
}
export default createReducer(initialState, builder => builder
  .addCase(updateUserId, (state, action) => {
    state.userId = action.payload
    return
  })
  .addCase(updateToken, (state, action) => {
    state.token = action.payload
    return
  })
)
export { initialState as userState }
